export default __webpack_public_path__ + "static/media/Hood of the Usurper.eb8c5efa.jpg";